import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { BETA_URL } from "../config";

// Sticky top nav shared across the marketing pages.
export function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setMenuOpen(false), [pathname]);

  return (
    <header className="nav">
      <div className="wrap nav-inner">
        <Link to="/" className="brand">
          <span className="dot" />
          KinSafe
        </Link>
        <button
          className="nav-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>
        <nav
          id="primary-navigation"
          className={"nav-links" + (menuOpen ? " open" : "")}
          aria-label="Primary navigation"
        >
          <NavLink
            to="/demo"
            className={({ isActive }) =>
              "nav-link" + (isActive ? " active" : "")
            }
          >
            Try the sliders
          </NavLink>
          <NavLink
            to="/grade"
            className={({ isActive }) =>
              "nav-link" + (isActive ? " active" : "")
            }
          >
            Grade your PC
          </NavLink>
          <NavLink
            to="/hardware"
            className={({ isActive }) =>
              "nav-link" + (isActive ? " active" : "")
            }
          >
            Hardware load
          </NavLink>
          <Link className="btn btn-primary btn-sm" to={BETA_URL}>
            Join the beta
          </Link>
        </nav>
      </div>
    </header>
  );
}
